export const TOKEN_KEY = 'TOKEN__'
export const USER_INFO_KEY = 'USER_INFO__'
export const AUTH_KEY = 'AUTH_KEY__'
export const MENU_KEY = 'MENU__'
export const GUIDE_KEY = 'GUIDE__'
export const PROVIDER_KEY = 'PROVIDERS__'
export const ACCOUNT_KEY = 'ACCOUNT_KEY__'
export const ROLE_KEY = 'ROLE_KEY__'
export const TAB_KEY = 'TAB_KEY__'
export const OUTER_TOKEN_KEY = 'OUTER_TOKEN__'
export const DEFAULT_CACHE_TIME = 60 * 60 * 24 * 7
export const APP_LOCAL_CACHE_KEY = 'APP_LOCAL_CACHE_KEY'
export const APP_SESSION_CACHE_KEY = 'COMMON__SESSION__KEY__'
export const PURCHASE_RECORD_PARAMS_KEY = 'PURCHASE_RECORD_PARAMS_KEY'
export enum CacheTypeEnum {
  SESSION,
  LOCAL
}
